import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AgentAuth from "@/pages/AgentAuth";

export const Route = createFileRoute("/agent-auth")({
  head: () => seoHead("/agent-auth"),
  component: AgentAuth,
});
